import React from 'react';
import { useTranslation } from 'react-i18next';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { IInitialState } from '../../../../reduxService';
import { useAppDispatch, useAppSelector } from '../../../../reduxService/hooks';
/* import { IProjectResultResponse } from '../../../MacRO1/api/IApiResponse';
import { getActionByProjectType } from '../../../actionMap'; */
import LogoMaccaferri from '../../../images/LogoMaccaferri.svg';
import LogoMacRODesign from '../../../images/logo_negativo.png';
import { endpoint } from '../../../pages';
import { isAdminUser } from '../../../store/user/utils';
import Breadcrumb from './Breadcrumb/Breadcrumb';
import './Header.scss';
import LanguageButton from './LanguageButton/LanguageButton';
import NewButton from './NewButton/NewButton';
import OpenButton from './OpenButton/OpenButton';
import SaveButton from './SaveButton/SaveButton';
import UserButton from './UserButton/UserButton';
import HelpButton from './HelpButton/HelpButton';
import HorizontalLinearStepper from './Stepper/Stepper';
import { Button, Box } from '@mui/material';
import DeviceHubIcon from '@mui/icons-material/DeviceHub';
import RunButton from './RunButton/RunButton';
import ExportButton from './ExportButton/ExportButton';
import { useSelector } from 'react-redux';
import { RootState } from '../../../../reduxService';

const Header = () => {
    const { t } = useTranslation();
    const navigate = useNavigate();
    const dispatch = useAppDispatch();
    const [allButtonVisible, setAllButtonVisible] = React.useState<boolean>();
    const [inResults, setInResults] = React.useState<boolean>();
    /*     const { selectResults, cleanResults } = getActionByProjectType(); */

    /* const results: IInitialState<IProjectResultResponse> = useAppSelector(selectResults as any); */ //TODO aggiungi Macro2
    const location = useLocation();

    const currentProjectBase = useSelector((state: RootState) => {
        return { ...state.projectInfo.data };
      });

    React.useEffect(() => {
        setAllButtonVisible(location.pathname.split("/")[1] == 'designCondition' || location.pathname.split("/")[1] == 'results');
        //console.log(location.pathname.split("/")[1]);
        setInResults(location.pathname.split("/")[1] == 'results' && currentProjectBase.hasBeenSent);
    }, [location.pathname, currentProjectBase.hasBeenSent]);

    const handleGotoHome = () => {
        /*         dispatch(cleanResults()); */
        navigate(endpoint.home);
    };

    const handleGotoHub = () => {
        /*         dispatch(cleanResults()); */
        let url = process.env.REACT_APP_EDESIGN_PORTAL_URL as string;
        window.location.replace(url);
    };

    return (
        <header id='header-macro'>
            <div className='head'>
                <div className='leftHead'>
                    <a href="/">
                        <img className='logoMacra' src={LogoMacRODesign} alt='Maccaferri logo header' />
                    </a>
                    <Box sx={{display: {md: 'flex', sm: 'flex', xs: 'none'}}}>
                        <Button
                            className='backToHub'
                            onClick={handleGotoHub}
                            variant="outlined"
                            startIcon={<DeviceHubIcon />}
                        >
                            {t('header_back_to_hub')}
                        </Button>
                    </Box>
                </div>
                <Box sx={{display: {md: 'flex', sm: 'none', xs: 'none'}}}>
                    <img className='cursor-pointer logoMaccaferri' src={LogoMaccaferri} alt='Logo Maccaferri' onClick={handleGotoHome} />
                </Box>
            </div>
            <nav className='menu'>
                <div>
                    {allButtonVisible && <NewButton className='btn' />}
                    <OpenButton className='btn' />
                    {allButtonVisible && (
                        <>
                            <SaveButton className='btn' />
                        </>
                    )}
                    <LanguageButton className='btn' />

                    {inResults && <ExportButton className='btn' />}
                    <HelpButton className='btn' />
                </div>
                <div className='d-flex'>
                    <UserButton />
                    {/*allButtonVisible && <RunButton />*/}
                </div>
            </nav>
            <div>
                {location.pathname !== '/' && <HorizontalLinearStepper />}
            </div>
        </header>
    );
};
export default Header;
